import { Component, ViewChild } from '@angular/core';
import { ProductCategories } from 'src/app/models/product-categories.model';
import { CrudService } from 'src/app/services/crud.service';
import CustomStore from 'devextreme/data/custom_store';
import { environment } from 'src/environments/environment';
import { HorizontalMenuService } from 'src/app/services/horizontalmenu.service';
import { ConfirmationService } from 'src/app/services/confirmation.service';
import { DxDataGridComponent, DxDataGridModule } from 'devextreme-angular';

@Component({
    selector: 'app-product-categories',
    templateUrl: './product-categories.component.html',
    styleUrls: ['./product-categories.component.css'],
    imports: [ DxDataGridModule ],
    standalone: true
})
export class ProductCategoriesComponent {
  private apiUrl: string = environment.baseApiUrl;
  dataSource: any;
  editProdCategories: boolean = false;

  @ViewChild("productCategoryGrid", { static: false }) public dataGrid: DxDataGridComponent;

  constructor(private crudService: CrudService,
      private horizontalMenuService: HorizontalMenuService, private confirmationService:ConfirmationService) 
  {

    this.dataSource = new CustomStore<any>({
      load: async () => {
        return await new Promise((resolve) => {
          this.crudService.getData(`${this.apiUrl}product-categories`).subscribe((result: any) => {
            resolve(result.data);
          })
        })
    },
      insert: async (values) => {
        const userDetails = localStorage.getItem('userDetails');
        const parsedDetails = JSON.parse(userDetails || '{}');
        values.group_id = parsedDetails.data.group_id;
        values.location_id = parsedDetails.data.location_id;
        return await new Promise((resolve) => {
          this.crudService.insertData(`${this.apiUrl}product-categories`, values)
          .subscribe((result: any) => {
            resolve(result);
          });
        });
      },
      update: async (key, values) => {
        return await new Promise((resolve) => {
          this.crudService.updateData(`${this.apiUrl}product-categories`, key.id, values)
          .subscribe((result: any) => {
            resolve(result);
          });
        });
      },
      remove: async (key) => {
        return await new Promise((resolve) => {
          this.crudService.deleteData(`${this.apiUrl}product-categories`, key.id)
          .subscribe((result: any) => {
            resolve(result);
          });
        });
      }
    });
    this.horizontalMenuService.editProductCategories$.subscribe((value: boolean) => {
      this.editProdCategories = value;
    });
  }

  onHiding(event: any) {
    console.log("test", event);
    this.confirmationService.checkUnsaved(event, this.dataGrid, (value: boolean) => {
        this.horizontalMenuService.seteditProductCategories(value);
        console.log("Popup visibility should be set to:", value);
    });
    this.horizontalMenuService.seteditProductCategories(false);
}


}
